export default __webpack_public_path__ + "static/media/send.f7de3060.svg";